import { useCallback } from 'react'
import { useUserModules } from '../contexts/UserModuleContext'
import { ModuleType } from '../types/modules'
import { isLabAppEnabled } from '../config/labApps'

/**
 * L'accès de l'utilisateur courant aux applications du Lab Studio.
 *
 * L'interrupteur posé dans l'administration (permissions `app:` du module
 * lab) ne vaut que s'il se voit PARTOUT où l'application se mentionne : les
 * cartes du Lab Studio, mais aussi les actions rapides de l'accueil, les
 * compteurs du tableau de suivi, le fil d'activité, l'accès rapide de la
 * barre latérale — et la route elle-même. Une application coupée qui reste
 * lançable depuis l'accueil n'est pas coupée.
 *
 * Un seul endroit lit donc la règle, et chaque surface lui demande. La règle
 * elle-même vit dans `config/labApps` (aucun réglage vaut tout ouvert, pour
 * ne pas fermer le Lab aux comptes historiques).
 */
export function useLabAppAccess() {
  const { user } = useUserModules()
  const labPermissions = user?.modules?.find(
    (m) => m.moduleType === ModuleType.LAB && m.isEnabled,
  )?.permissions

  const isAppEnabled = useCallback(
    (appId: string) => isLabAppEnabled(labPermissions, appId),
    // Les permissions sont un tableau reconstruit à chaque réponse du
    // profil : la clé stable est leur contenu, pas leur référence.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(labPermissions ?? null)],
  )

  return { isAppEnabled }
}
